import * as Vue from 'vue'
import { createApp } from 'vue'
import { io } from 'socket.io-client'
import PuAlert from '@/layouts/components/popup-alert/PuAlert.vue'

// "undefined" means the URL will be computed from the `window.location` object
const URL = process.env.VUE_APP_URL_SOCKET

export const socket = io(URL, { transports: ['websocket'] })

// socket.on('connect', () => {
  // io.connected = true
  // socket.emit('joinRoom', 'asdasd')
// })

// socket.on('disconnect', () => {
//   io.connected = false
// })

// socket.on('foo', (...args) => {
//   // io.fooEvents.push(args);
// })

// socket.on('alert', (...args) => {
//   //
//   let data = args

//   return data
// })

// socket.on('bar', (...args) => {
//   //   io.barEvents.push(args);
// })


export function JoinRoom(room) {
  if (room) {
    console.log(`Joining room: ${room}`)
    socket.emit('joinRoom', room)
  } else {
    console.error('Room name is required')
  }
}
